export const CHANGE_TYPE = 'CHANGE_TYPE';

export const FETCHING = 'FETCHING';
export const FETCHING_FINISHED = 'FETCHING_FINISHED';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const VIDEO_UPLOADED = 'VIDEO_UPLOADED';
export const VIDEO_IMAGE_UPLOADED = 'VIDEO_IMAGE_UPLOADED';
